import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { useToast } from "hooks/useToast";
import { useSubmitFilingDraftCardMutation } from "store/apis/filingDraftReview";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";

export const ApproveFilingDraft = ({
  isOpen,
  close,
  groupId,
  draftId,
  closeParent,
}: {
  groupId: string;
  draftId: string;
  closeParent: () => void;
} & ModalProps) => {
  const [approveFilingDraft, { isLoading }] = useSubmitFilingDraftCardMutation({
    fixedCacheKey: `submitDftFilingDraft_${draftId}`,
  });
  const { alertToast, successToast } = useToast();

  const handleApproveFilingDraft = async () => {
    try {
      await approveFilingDraft({
        groupId,
        draftId,
        isApproved: true,
      }).unwrap();
      close();
      closeParent();
      successToast({
        message: "Filing Draft approved successfully.",
      });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal
          type="warning"
          title="Approve filing draft?"
          showCloseButton={false}
        >
          <div className="t-text-body-sm t-text-text-30">
            Are you sure you want to approve this draft? Once approved, we will
            proceed with filing.
          </div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Go back</Button>
          </Modal.RawClose>
          <Button
            customType="primary"
            onClick={handleApproveFilingDraft}
            isLoading={isLoading}
          >
            Yes, approve draft
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Approve Draft for Final Filing?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-text-30 t-text-body-sm">
            Are you sure you want to approve this draft? Once approved, we will
            proceed with filing.
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            customType="primary"
            onClick={handleApproveFilingDraft}
            isLoading={isLoading}
          >
            Proceed with filing
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
